import React from 'react';
import queryString from 'query-string';
import _ from 'lodash';
import Navigation from 'Components/Navigation';
import LoadingPageContent from 'Components/LoadingPageContent';
import UserEditForm from 'Components/UserEditForm';
import { userService, authorizationService, regionservice } from '../_services';
import { withAuthenticatedUser } from 'Components/withAuthenticatedUser';
import { withRouter } from 'Components/withRouter';

class UserPage extends React.Component {
    constructor(props) {
        super(props);

        const values = queryString.parse(this.props.router.location.search);

        this.state = {
            loaded: false,
            regions: null,
            permissions: null,
            userId: values.id,
            editUser: null
        };

        this.onFormSubmit = this.onFormSubmit.bind(this);
    }

    fetchData = (userId) => {

        var page = this;

        regionservice.getRegions()
            .then(data => {
                this.setState({
                    regions: data
                });
                return authorizationService.getPermissions()
            })
            .then(data => {
                this.setState({
                    permissions: data
                });

                if (userId === "-1") {

                    var state = {
                        isNew: true,
                        loaded: true
                    };
    
                    page.setState(state);

                    return Promise.reject('Creating new user');
                }
                return userService.getUser(userId);
            })
            .then(user => {

                var state = {
                    loaded: true,
                    editUser: user
                };

                page.setState(state);
            })
            .catch(error => console.log(error));
    }

    componentDidMount() {
        this.fetchData(this.state.userId);
    }

    onFormSubmit(formData) {

        var userData = {
            permissions: [],
            accounts: []
        };

        var checkboxKeys = ['active', 'allow_uem'];

        formData.forEach((value, key) => {

            if (_.some(checkboxKeys, k => k === key)) {
                userData[key] = (value === 'on' ? true : false);
            }
            else if (_.startsWith(key, 'Permission')) {

                var re = /^Permission_(\w+)/;
                var result = re.exec(key);

                if (result && value === 'on') {
                    userData.permissions.push(result[1]);
                }
            }
            else if (_.startsWith(key, 'UserCust')) {
                
                var re = /^UserCust(\w+)/;
                var result = re.exec(key);

                if (result && value === 'on') {
                    userData.accounts.push(result[1]);
                }
            }
            else {
                userData[key] = value;
            }
            
         });

         checkboxKeys.forEach(k => {
            if (formData.has(k) !== true) {
                userData[k] = false;
            }
         });

         var navigate = this.props.router.navigate;

        userService.submitUser(userData)
            .then(response => {
                if (response.status === 200) {
                    navigate('/admin_users');
                } else if (response.status === 201) {
                    this.setState({
                        isNew: false
                    });
                    navigate('/user?id=' + response.userId);
                } else {
                    if (response.message !== undefined && response.message != null)
                        alert(response.message);
                    console.log(response);
                }
            })
            .catch(error => {
                alert(error);
            });
    }

    render() {

        if (!this.state.loaded)
            return (<LoadingPageContent />);

        return (
            <div id="user">
                <Navigation authenticatedUser={this.props.authenticatedUser} />
                <div className="container-fluid padding-lr55 bg-form">
                    <div className="row h3">
                        <div className="col-xs-12">{this.state.isNew ? "Add" : "Edit"} Web User</div>
                    </div>
                </div>
                <div className="container-fluid padding-lr55 bg-form">
                    <UserEditForm isNew={this.state.isNew} currentUser={this.props.authenticatedUser} editUser={this.state.editUser} regions={this.state.regions} permissions={this.state.permissions} onFormSubmit={this.onFormSubmit} />
                </div>
            </div>
            );
    }
}

const DecoratedUserPage = withAuthenticatedUser(withRouter(UserPage));

export { DecoratedUserPage as UserPage };